// extracted by mini-css-extract-plugin
export var lg = "_15-4";
export var md = "_15-3";
export var sm = "_15-2";
export var xs = "_15-1";
export var xxs = "_15-0";